// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import Icon from 'app/common/components/Icon';
import { Div } from 'app/common/components/AccessibleElement';
import 'app/common/components/HelpButton/HelpButton.scss';

import type { KindType } from 'app/common/types';

const bem = bemify('support-button');

type HelpButtonProps = {
  shouldHideButton?: boolean,
  onClick: () => void,
  icon: string,
  children: string,
  className?: string,
  kind?: KindType,
};

const HelpButton = ({
  shouldHideButton,
  children,
  className,
  kind,
  icon,
  onClick,
}: HelpButtonProps) => {
  const style = shouldHideButton
    ? {
        display: 'none',
      }
    : {};

  return (
    <Div
      className={bem(className, toModifiers(kind))}
      kind={kind}
      onClick={onClick}
      style={style}
    >
      <Icon className={bem('__icon')} type={icon} />
      {children}
    </Div>
  );
};

// Export a class so we can use it as a `ref`
export default class HelpButtonRefable extends React.Component<HelpButtonProps> {
  render() {
    return <HelpButton {...this.props} />;
  }
}
